
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormContextAMR } from "../form-context";
import medsCheckLogo from "../images/meds-check-logo.png";
import ontarioLeftLogo from "../images/ontario-logo-new.png";

import { Container, Section, P, CompliancyRequirements } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { ServiceInfo } from "../components/ServiceInfo";

import { EligibilityInformation } from "../components/EligibilityInformation";
import { PatientInformation } from "../components/PatientInformation";
import { PatientContactInformation } from "../components/PatientContactInformation";
import { AlternateCaregiverInformation } from "../components/AlternateCaregiverInformation";
import { PrimaryHealthcareProvider } from "../components/PrimaryHealthcareProvider";
import { ClinicalServiceType } from "../components/ClinicalServiceType";
import { ConsentInformation } from "../components/ConsentInformation";
import { PreAssessmentSpecialPopulations } from "../components/PreAssessmentSpecialPopulations";
import { AllergyInformation } from "../components/AllergyInformation";
import { LifestyleFactors } from "../components/LifestyleFactors";
import { Vaccines } from "../components/Vaccines";
import { Symptoms } from "../components/Symptoms";
import { MedicalHistorySection } from "../components/MedicalHistorySection";
import { Interventions } from "../components/Interventions";
import { ClassificationofMinorAilment } from "../components/ClassificationofMinorAilment";
import { TreatmentInformation } from "../components/TreatmentInformation";
import { EducationalInformation } from "../components/EducationalInformation";
import { ReferralsAndNotifications } from "../components/ReferralsAndNotifications";
import { PrescribingPharmacistInformation } from "../components/PrescribingPharmacistInformation";
import { PharmacyInformation } from "../components/PharmacyInformation";
import { InsuranceInformation } from "../components/InsuranceInformation";
import { TreatmentPlan } from "../components/TreatmentPlan";
import { FollowUpAppointments } from "../components/FollowUpAppointments";
import { PharmacistMonitoringPlans } from "../components/PharmacistMonitoringPlans";
import { BillingInformation } from "../components/BillingInformation";
import { MedicalHistoryInformation } from "../components/MedicalHistoryInformation";
import { Adherence } from "../components/Adherence";
import { Medications } from "../components/Medications";
import { AMRGoals } from "../components/AMRGoals";
import { MedicationReasonCheckList } from "../components/MedicationReasonCheckList";
import { ClinicalNeedCheckList } from "../components/ClinicalNeedCheckList";
import { ClinicalNeedPharmacistCheckList } from "../components/ClinicalNeedPharmacistCheckList";
import { CompletenessCheckList } from "../components/CompletenessCheckList";
import { ConsultedSourcesCheckList } from "../components/ConsultedSourcesCheckList";

export const PharmacistsWorksheetForm = () => {
  const {
    formType,
    clinicalServiceName,
    patient,
    preAssessment,
    clinicalAssessment,
    documentation,
    education,
    patientMedications,
    medications,
    startDateTime,
    endDateTime,
  } = useContext(FormContextAMR);
  const { serviceId } = useContext(FormContextAMR);

  // Get healthAndWellness data from Redux store for lifestyle factors
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const healthAndWellness = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.healthAndWellness;

  return (
      <Container>
        <FormHeader formType = {formType} />
        <div className="space-y-[0.166667in] mx-[0.375in] mt-[0.25in]">
          <ServiceInfo 
            referral = {null} 
            isReferral = {false} 
            formType = {formType}
            clinicalServiceName = {clinicalServiceName}
            patient = {patient}
            preAssessment = {preAssessment}
            startDateTime = {startDateTime} />
          <EligibilityInformation  formType = {formType}/>
          <PatientInformation  formType = {formType} patient = {patient} preAssessment = {preAssessment} showAgeAlert={false} />
          <InsuranceInformation  formType = {formType} patient = {patient}/>
          <PatientContactInformation  formType = {formType} patient = {patient}/>
          <AlternateCaregiverInformation formType = {formType} patient = {patient} />
          <PrimaryHealthcareProvider  formType = {formType}  patient = {patient}/>
          <ClinicalServiceType  formType = {formType} patient={patient} preAssessment={preAssessment} />
          <ConsentInformation formType = {formType} patient={patient} preAssessment = {preAssessment} startDateTime={startDateTime}/>
          <CompliancyRequirements formType={formType} pharmacyName="[name of pharmacy]" />
          <PreAssessmentSpecialPopulations formType = {formType} preAssessment={ preAssessment}/>
          <AllergyInformation formType = {formType} patient={patient} clinicalAssessment = {clinicalAssessment}/>
          <MedicalHistoryInformation formType = {formType} patient={patient} clinicalAssessment = {clinicalAssessment}/>
          <Adherence formType = {formType} clinicalAssessment={clinicalAssessment}/>
          <LifestyleFactors formType = {formType} clinicalAssessment = {healthAndWellness} patient={patient} />
          <Vaccines formType= {formType} education={education} patientMedications={patientMedications} />
          <MedicationReasonCheckList formType = {formType} preAssessment={preAssessment} />
          <ClinicalNeedCheckList
            formType={formType}
            patient={patient}
            preAssessment={preAssessment}
            medications={medications}
            patientMedications={patientMedications}
            clinicalAssessment={clinicalAssessment}
          />
          <ClinicalNeedPharmacistCheckList
            formType={formType}
            patient={patient}
            preAssessment={preAssessment}
            medications={medications}
            patientMedications={patientMedications}
            clinicalAssessment={clinicalAssessment}
            clinicalServiceName={clinicalServiceName}
          />
          <AMRGoals formType = {formType} medications = {medications} />
          <Medications formType = {formType} medications = {medications} patientMedications = {patientMedications} />
          <ConsultedSourcesCheckList formType = {formType} documentation={documentation} />
          <CompletenessCheckList formType = {formType} documentation={documentation} />
          <FollowUpAppointments formType={formType} education={education} clinicalServiceName={clinicalServiceName} serviceId={serviceId} />
          <ReferralsAndNotifications formType={formType} documentation ={documentation} />
          <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
          <PharmacyInformation formType = {formType}/>
        </div>
        <FormFooter />
      </Container>
    );
};
